import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { connectAutocomplete } from 'instantsearch.js/es/connectors';
import { BaseWidget, NgAisConfigureModule, NgAisInstantSearch } from 'angular-instantsearch';
import { Subject } from 'rxjs';
import { DatastateManagementService } from 'src/app/modules/admin/datastate-management/datastate-management.service';
import { AutomateDataState } from 'src/app/modules/admin/profile-management/profile-detail/automate-datastate-log/automate-datastate-model';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, takeUntil, tap } from 'rxjs/operators';
import { AutocompleteScrollDirective } from '../algolia-autocomplete/autocomplete-scroll.directive';
import { SearchParameters } from 'angular-instantsearch/instantsearch/instantsearch';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatSelectScrollDirective } from './mat-select-scroll.directive';

@Component({
  selector: 'app-algolia-mat-select',
  templateUrl: './algolia-mat-select.component.html',
  styleUrls: ['./algolia-mat-select.component.scss']
})
export class AlgoliaMatSelectComponent extends BaseWidget implements OnInit, AfterViewInit, OnDestroy {
  @Input() bankControl: FormControl = new FormControl();
  @Input() required: boolean = true;

  @Input() propValue: string = 'objectID';
  @Input() propDisplay: string = 'displayName';
  @Input() placeholder: string = 'Search...';
  @Input() placeholderLabel: string = 'Search...';

  @Input() configuration: SearchParameters = null;
  @Input() typeName: string = null;

  @Output() configurationChange = new EventEmitter<SearchParameters>();
  @Output() onQuerySuggestionClick = new EventEmitter<string>();
  @Output() onQueryEnter = new EventEmitter<string>();
  @Output() onQueryClean = new EventEmitter<void>();
  @Output() onRefresh = new EventEmitter<void>();

  @ViewChild(MatSelectScrollDirective) matSelectScroll: MatSelectScrollDirective;

  state: {
    query: string;
    refine: Function;
    indices: any[];
    results: object;
  };
  isNext: boolean = false;
  disableNext: boolean = false;

  sizePage: number = 20;
  _onDestroy: Subject<void> = new Subject();
  automateDataStateLst: AutomateDataState[] = null;
  bankSearch: FormControl = new FormControl('');
  isSetting: boolean = true;

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchParent: NgAisInstantSearch,
    private dataStateService: DatastateManagementService,
  ) {
    super('AutocompleteComponent');
  }

  ngOnInit(): void {
    this.getAutomateDataState();
    this.createWidget(connectAutocomplete, {});
    super.ngOnInit();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.bankControl?.value)
        this.refreshAlgoliaSearch(this.bankControl?.value);
    }, 100);

    this.matSelectScroll.matSelect.openedChange.pipe(
      filter(opened => !opened),
      takeUntil(this._onDestroy)
    ).subscribe(() => this.refreshAlgoliaSearch(this.bankControl?.value || ''));

    this.bankControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this._onDestroy)
    ).subscribe((x) => {
      this.refreshAlgoliaSearch(x);
      this.onQueryEnter.emit(x);
    });

    this.bankSearch.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this._onDestroy)
    ).subscribe((x) => {
      if (x) this.refreshAlgoliaSearch(x)
    });

    this.instantSearchParent.change.asObservable()
      .pipe(
        debounceTime(500),
        tap(x => {
          this.isSetting = false;
          try {
            if (this.matSelectScroll?.elePanel && !this.isNext)
              this.matSelectScroll.elePanel.scrollTo({ top: 0, behavior: "smooth" });

            this.isNext = false;
            let firstIndices = this.state?.indices[0];
            if (firstIndices?.results?.hits?.length == firstIndices?.results?.nbHits)
              this.disableNext = true;
          }
          catch (ex) {
            console.error(ex);
          }
        }),
        takeUntil(this._onDestroy)
      ).subscribe();
  }

  public ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    super.ngOnDestroy();
  }

  async getAutomateDataState() {
    if (!this.automateDataStateLst) {
      const result = await this.dataStateService.getAutomateDataState(this.typeName).toPromise();
      this.automateDataStateLst = result?.result || [];
    }
  }

  public refreshAlgoliaSearch(key: string) {
    this.disableNext = false;
    this.state.refine(key, this.configuration);
  }

  onScroll() {
    if (!this.isNext && this.configuration) {
      this.isNext = true;
      this.configuration.hitsPerPage += this.sizePage;
      this.refreshAlgoliaSearch(this.state?.query || this.bankSearch?.value || '');
    }
  }
}
